module.exports = __webpack_public_path__ + "img/make_transfer.e3f2c5be.svg";